
import Util from "@/ts/Util";
import feather from "feather-icons";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
  props: {
    userName: String,
    userPhoto: String,
    clickLogout: Function,
    clickContact: Function,
    clickChange: Function,
    drawer: Boolean,
  },
})
export default class Slidetify extends Vue {
  static navigationItems: any = [];
  static instance: any;
  options = Slidetify.navigationItems;
  currentDrawer = false;

  mounted() {
    this.currentDrawer = this.$props.drawer;
    Slidetify.instance = this;
  }

  updated() {
    feather.replace();
  }

  static refresh() {
    const layoutConfigSlideNav = JSON.parse(
      sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
    ).CONFIGURATIONS.APP_LAYOUT_CONFIG.slideNav;

    layoutConfigSlideNav.push({
      id: "4",
      name: "Fale Conosco",
      icon: ["volume"],
      click: [],
    });

    if (sessionStorage.getItem("USER_ID")) {
      layoutConfigSlideNav.push({
        id: "8",
        name: "Sair",
        icon: ["sign-out-alt"],
        click: [],
      });
    }

    Slidetify.navigationItems =
      Slidetify.instance.mapOptions(layoutConfigSlideNav);

    const instance = Slidetify.instance;
    if (instance) {
      instance.options = Slidetify.navigationItems;
    }
  }

  @Watch("$props.drawer")
  drawerWatcher() {
    this.currentDrawer = !this.currentDrawer;
  }

  mapOptions(items: any[]): any {
    let mappedItems: any = [];

    mappedItems = items.map((i: any) => {
      const defaultItems: any = Slidetify.defaultItems();
      const item = defaultItems.find((o: any) => i.id == o.id);
      if (!item) mappedItems = [];

      return {
        ...item,
        name: i.name.split("_")[0],
        icon: i.icon.map(() => ["fal", i.icon[0]])[0],
        child: this.mapOptions(i.child || []) || [],
      };
    });

    return mappedItems;
  }

  static defaultItems(): any {
    return [
      {
        id: "0",
        name: "Perfil",
        icon: ["fal", "user"],
        router: "Perfil",
        click: [],
        child: [],
      },
      {
        id: "1",
        name: "Dependentes",
        icon: ["fal", "users"],
        router: "Dependents",
        click: [],
        child: [],
      },
      {
        id: "2",
        name: "Carteira",
        icon: ["fal", "wallet"],
        router: "Carteira",
        click: [],
        child: [],
      },
      {
        id: "3",
        name: "Documentos",
        icon: ["fal", "file"],
        router: "Documents",
        click: [],
        child: [],
      },
      {
        id: "4",
        name: "Fale Conosco",
        icon: ["fal", "volume"],
        router: "",
        click: [Slidetify.instance.$props.clickContact],
        child: [],
      },
      {
        id: "5",
        name: "Boletos",
        icon: ["fal", "file-alt"],
        router: "MeusBoletos",
        click: [],
        child: [],
      },
      {
        id: "6",
        name: "Pesquisa de Satisfação",
        icon: ["fal", "clipboard"],
        router: "Surveys",
        click: [],
        child: [],
      },
      {
        id: "7",
        name: "Mais Informações",
        icon: ["fal", "plus-square"],
        router: "",
        click: [],
        child: [],
      },
      {
        id: "8",
        name: "Sair",
        icon: ["fal", "sign-out-alt"],
        router: "",
        click: [Slidetify.instance.$props.clickLogout],
        child: [],
      },
      {
        id: "9",
        name: "Pessoas no Clube",
        icon: ["far", "umbrella"],
        router: "PessoasNoClube",
        click: [],
      },
      {
        id: "10",
        name: "Trocar de Clube",
        icon: ["far", "sync"],
        router: "",
        click: [Slidetify.instance.$props.clickChange],
      },
      {
        id: "11",
        name: "Sobre",
        icon: ["far", "info-circle"],
        router: "About",
        click: [],
      },
      {
        id: "12",
        name: "Aluguel de Espaços",
        icon: ["far", "key"],
        router: "SpaceRent",
        click: [],
      },
      {
        id: "13",
        name: "Perfil",
        icon: ["fal", "user"],
        router: "PerfilDelivery",
        click: [],
        child: [],
      },
    ];
  }

  logOff() {
    Util.logOff();
  }
}
